import React from 'react';
import { useIntl } from 'react-intl-next';
import { AnalyticsContext } from '@atlaskit/analytics-next';
import { ModalBody, ModalFooter, ModalHeader, ModalTitle, ModalTransition } from '@atlaskit/modal-dialog';
import { Button } from '../Button';
import { Modal } from '../ModalDialog';
import messages from './messages';
var screen = 'linkCreateExitWarningScreen';
var context = {
  component: screen,
  source: screen
};
export var ConfirmDismissDialog = function ConfirmDismissDialog(_ref) {
  var active = _ref.active,
    onClose = _ref.onClose,
    onCancel = _ref.onCancel;
  var intl = useIntl();
  var onCancelDismiss = function onCancelDismiss() {
    return onClose();
  };
  var onConfirmDismiss = function onConfirmDismiss() {
    onClose();
    onCancel === null || onCancel === void 0 || onCancel();
  };
  return /*#__PURE__*/React.createElement(ModalTransition, null, active && /*#__PURE__*/React.createElement(AnalyticsContext, {
    data: context
  }, /*#__PURE__*/React.createElement(Modal, {
    testId: "link-create-confirm-dismiss-dialog",
    screen: screen,
    onClose: onCancelDismiss,
    width: "small"
  }, /*#__PURE__*/React.createElement(ModalHeader, null, /*#__PURE__*/React.createElement(ModalTitle, null, intl.formatMessage(messages.title))), /*#__PURE__*/React.createElement(ModalBody, null, intl.formatMessage(messages.description)), /*#__PURE__*/React.createElement(ModalFooter, null, /*#__PURE__*/React.createElement(Button, {
    actionSubjectId: "cancel",
    appearance: "subtle",
    onClick: onCancelDismiss
  }, intl.formatMessage(messages.cancelButtonLabel)), /*#__PURE__*/React.createElement(Button, {
    actionSubjectId: "confirm",
    appearance: "primary",
    onClick: onConfirmDismiss
  }, intl.formatMessage(messages.confirmButtonLabel))))));
};